import { create } from 'zustand'

export type Template = any

interface AddFromTemplatesState {
  allTemplates: Template[]
  availableTemplates: Template[]
  selectedTemplates: Template[]
  setAllTemplates: (templates: Template[]) => void
  addTemplate: (templateId: string) => void
  removeTemplate: (templateId: string) => void
  clearSelection: () => void
  isSelected: (templateId: string) => boolean
}

export const useAddFromTemplatesStore = create<AddFromTemplatesState>(
  (set, get) => ({
    allTemplates: [],
    availableTemplates: [],
    selectedTemplates: [],

    setAllTemplates: (templates) =>
      set(() => ({
        allTemplates: templates,
        availableTemplates: templates.filter(
          (t) => !get().selectedTemplates.some((st) => st.id === t.id)
        ),
      })),

    addTemplate: (templateId) =>
      set((state) => {
        const template = state.availableTemplates.find(
          (t) => t.id === templateId
        )
        if (!template) return state

        return {
          availableTemplates: state.availableTemplates.filter(
            (t) => t.id !== templateId
          ),
          selectedTemplates: [...state.selectedTemplates, template],
        }
      }),

    removeTemplate: (templateId) =>
      set((state) => {
        const template = state.selectedTemplates.find(
          (t) => t.id === templateId
        )
        if (!template) return state

        return {
          selectedTemplates: state.selectedTemplates.filter(
            (t) => t.id !== templateId
          ),
          availableTemplates: [...state.availableTemplates, template],
        }
      }),

    clearSelection: () =>
      set((state) => ({
        selectedTemplates: [],
        availableTemplates: state.allTemplates,
      })),

    isSelected: (templateId) =>
      get().selectedTemplates.some((t) => t.id === templateId),
  })
)
